import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

//Layout
import MainLayout from "Layouts/Main";

// styles
import "./styles.scss";

//assets
import assets from "../../../../Assets";

// utils
import { validateInput } from "Services/Utils/validateInput";

//Custom Components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import DatePicker from "Components/Common/DatePicker";
import ErrorMessage from "Components/ErrorMessage";
import SuccessCard from "Components/Common/SuccessCard";

//redux
import { useDispatch } from "react-redux";
import { editBanners, fetchIndividualBanner } from "../../../../Redux/Slices/contentManagementSlice";
import { uploadSingle } from "../../../../Redux/Slices/mainSlice";

const EditBannersAndPromotions = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [description, setDescription] = useState("");
  const [file, setFile] = useState("");
  const [title, setTitle] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const handleFileChange = (event) => {
    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    const selectedFile = event.target.files[0];
    if (!selectedFile) return; 

    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
  
    if (!allowedTypes.includes(selectedFile.type)) {
      setErrors({
        ...errors,
        file: "Only JPG, JPEG, and PNG files are allowed.",
      });
      return;
    }
    const uploadCB = (value) => {
      console.log(value)
      setFile(value.data.url);
    };
    dispatch(
      uploadSingle({
        data: formData,
        callBack: uploadCB,
      })
    );
  };

  const handleFromDate = (date) => {
    setStartDate(date ? new Date(date) : null)
  };
  const handleToDate = (date) => {
    setEndDate(date);
  };

  const formatDateToLocal = (dateString) => {
    const date = new Date(dateString);
  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  };

  const handleValidation = () => {
    let validationErrors = {};
  
    const titleErrors = validateInput("bannerTitle", title);
    if (titleErrors.bannerTitle) {
      validationErrors.bannerTitle = titleErrors.bannerTitle;
    }
  
    // const descriptionErrors = validateInput("description", description);
    // if (descriptionErrors.description) {
    //   validationErrors.description = descriptionErrors.description;
    // }
  
    const startDateErrors = validateInput("startDate", startDate);
    if (startDateErrors.startDate) {
      validationErrors.startDate = startDateErrors.startDate;
    }
  
    const endDateErrors = validateInput("endDate", endDate, startDate);
    if (endDateErrors.endDate) {
      validationErrors.endDate = endDateErrors.endDate;
    }
  
    const fileErrors = validateInput("file", file);
    if (fileErrors.file) {
      validationErrors.file = fileErrors.file;
    }
  
    setErrors(validationErrors);
    return validationErrors;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = handleValidation();
    if (Object.keys(validationErrors).length === 0) {
    // Handle form submission logic here
    const data = {
      "banner_title": title,
      "description": description,
      "start_date": formatDateToLocal(startDate),
      "end_date": formatDateToLocal(endDate),
      "banner_image": file
    }
    console.log(data);
    const editBannerCB = (value) => {
      setIsSuccess(true)
    }
    dispatch(
      editBanners({
        id,
        data:data,
        callBack:editBannerCB
      })
    )
  }
  };

   const existingDetailsCB = (value) => {
    console.log(value)
    setTitle(value.result.banner_title)
    setDescription(value.result.description)
    setStartDate(value.result.start_date)
    setEndDate(value.result.end_date)
    setFile(value.result.banner_image)
   }
  useEffect(()=>{
    console.log(id)
    dispatch(
      fetchIndividualBanner({
        data:{
          id
        },
        callBack:existingDetailsCB

      })
    )
  },[])


  return (
    <MainLayout pageName={"Content Management"}>
      {/* SuccessCard - Conditionally render */}
      {isSuccess && (
        <SuccessCard 
        title="Banner/Promotion Edited Successfully"
        subTitle="Banner/Promotion Details Edited Successfully."
        onClose={() => setIsSuccess(false)} // Close the SuccessCard
        onGoBack={() => navigate(-1)} // Navigate back
      />
      )}
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Banners List</p>
      </div>
      <form className="AddBannerContainer" onSubmit={handleSubmit}>
        {/* Header */}
        <div className="AddBannerContainerHeader">
          <h2>Edit Banners/Promotions Details</h2>
        </div>
        <hr style={{ border: "1px solid #E6E6E6" }} />
        <div className="AddBannerTextContainer">
          <p>Banner Title</p>
          <div className="AddBannerInputBoxContainer">
            <InputBox
              inputStyle={{
                border: "1px solid #B2BEC3",
                padding: "1px 2vh 1px 2vh",
                height: "7vh",
                boxShadow:'none',
                color: "black"
              }}
              name="videoLink"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
             {errors.bannerTitle && <ErrorMessage message={errors.bannerTitle} />}
          </div>
        </div>
        <div className="AddBannerTextContainer">
          <p>Description</p>
          <div className="AddBannerInputBoxContainer">
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows="5"
              placeholder="Enter description here"
              className="textAreaInput"
            />
            {errors.description && <ErrorMessage message={errors.description} />}
          </div>
        </div>
        <div className="AddBannerInputBoxBody">
          <div className="AddBannerInputContainer">
            <p>Start Date</p>
            <div className="AddBannerInputBoxContainer">
              <DatePicker
                placeholderText="DD/MM/YYYY"
                selected={startDate}
                minDate={new Date()}
                onChange={handleFromDate}
                border = {true}
                image = {false}
                format={"dd/MM/yyyy"} 
                width = '31.3vw'
                height = '6.5vh'
                radius = '6px'
              />
             {errors.startDate && <ErrorMessage message={errors.startDate} />}
            </div>
          </div>
          <div className="AddBannerInputContainer">
            <p>End Date</p>
            <div className="AddBannerInputBoxContainer">
            <DatePicker
                placeholderText="DD/MM/YYYY"
                selected={endDate}
                minDate = {startDate}
                onChange={handleToDate}
                border = {true}
                image = {false}
                format={"dd/MM/yyyy"} 
                width = '31.3vw'
                height = '6.5vh'
                radius = '6px'
              />
             {errors.endDate && <ErrorMessage message={errors.endDate} />}
            </div>
          </div>
        </div>
       
        <div className="AddBannerTextContainer">
          <p style={{marginBottom:'20px',marginTop:'10px'}}>Upload File</p>
          <div className="fileUploadContainer">
            <label htmlFor="uploadFile" className="uploadFileLabel">
              Upload
              <input
                type="file"
                id="uploadFile"
                accept=".jpg,.jpeg,.png,.webp"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </label>
            {errors.file && <div style={{marginTop:'1rem'}}> <ErrorMessage message={errors.file} /> </div>}
          </div>
          {file ? <p style={{marginTop:"1rem"}}>{file.split('---').pop()}
          {file ? (
                    <span
                      style={{
                        color: "red",
                        marginLeft: "10px",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                      onClick={() => setFile("")}
                    >
                      X
                    </span>
                  ) : (
                    ""
                  )}
          </p> : ""}
        </div>

        <div className="addBannerButtons">
          <div className="addBannerButtonContainer">
            <Button
              buttonStyle={{ height: "2vh", backgroundColor: "#FFFFFF" }}
              titleStlye={{ color: "#888888" }}
              title="Cancel"
              onClick={() => navigate(-1)}
            />
          </div>
          <div className="addBannerButtonContainer">
            <Button
              forForm={true}
              buttonStyle={{ height: "2vh" }}
              title="Save"
            />
          </div>
        </div>
      </form>
    </MainLayout>
  );
};

export default EditBannersAndPromotions;
